import { retryXTimesOnServerError, retryXTimesWithStatusException } from '@/api/helpers';

const ONE_HOUR = 3600000;
const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000;

export const MONITORING_LONG_POLL_OPTIONS = {
  refetchInterval: ONE_HOUR,
  gcTime: ONE_HOUR,
  staleTime: ONE_HOUR,
  refetchOnWindowFocus: false,
} as const;

export const STATIC_DATA_QUERY_OPTIONS = {
  staleTime: TWENTY_FOUR_HOURS,
  gcTime: TWENTY_FOUR_HOURS,
  retry: (failureCount: number, error: Error) => {
    return retryXTimesWithStatusException(failureCount, error, 401, 3);
  },
  refetchOnWindowFocus: false,
} as const;

export const DOCS_QUERY_OPTIONS = {
  ...STATIC_DATA_QUERY_OPTIONS,
  retry: (failureCount: number, error: Error) => {
    return retryXTimesOnServerError(failureCount, error, 3);
  },
} as const;
